// Strato "piattaforma" per la versione web/PWA: stessa interfaccia di window.tt (Electron),
// ma con le funzioni del browser. Il resto dell'app (src/renderer) è identico all'app desktop.
import type { TtApi } from '../preload/preload';

declare const __APP_VERSION__: string;

const KEY = 'tt.creds';

const tt: TtApi = {
  getCreds: async () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) ?? 'null');
    } catch {
      return null;
    }
  },
  setCreds: async (creds) => {
    if (creds) localStorage.setItem(KEY, JSON.stringify(creds));
    else localStorage.removeItem(KEY);
  },
  version: async () => __APP_VERSION__,
  setTray: async (_state, tooltip) => {
    if (tooltip) document.title = tooltip;
  },
  notify: async (title, body) => {
    try {
      if (!('Notification' in window)) return;
      if (Notification.permission === 'default') await Notification.requestPermission();
      if (Notification.permission !== 'granted') return;
      const reg = await navigator.serviceWorker?.getRegistration();
      if (reg) await reg.showNotification(title, { body, icon: 'icon-192.png' });
      else new Notification(title, { body });
    } catch {
      // notifiche non disponibili
    }
  },
  setTheme: async (theme) => {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#141826' : '#eef1f6');
  },
  configureUpdates: async () => undefined,
  installUpdate: async () => undefined,
  checkUpdates: async () => ({ status: 'latest' }),
  helloAvailability: async () => ({ status: 'unsupported', message: 'Non disponibile nella versione web.' }),
  helloVerify: async () => ({ ok: false, status: 'unsupported', message: 'Non disponibile nella versione web.' }),
  quickGet: async () => null,
  quickSet: async () => false,
  quickLogin: async () => ({ ok: false, status: 'unsupported', message: 'Non disponibile nella versione web.' }),
  // WhatsApp dal browser: sul telefono si apre «Condividi» con il file già allegato; sul computer il file si scarica
  // e si apre WhatsApp Web sulla chat giusta.
  whatsapp: async (phone, text, file) => {
    const digits = phone.replace(/\D/g, '');
    if (!/^\d{8,15}$/.test(digits)) throw new Error('Numero di telefono non valido');
    const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (file) {
      const f = new File([file.data as Uint8Array<ArrayBuffer>], file.name, { type: file.mime });
      if (mobile && navigator.canShare?.({ files: [f] })) {
        await navigator.share({ files: [f], text: text || undefined });
        return { mode: 'share', copied: false };
      }
      const url = URL.createObjectURL(f);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 30_000);
    }
    const q = `${text ? `?text=${encodeURIComponent(text)}` : ''}`;
    window.open(mobile ? `https://wa.me/${digits}${q}` : `https://web.whatsapp.com/send?phone=${digits}${text ? `&text=${encodeURIComponent(text)}` : ''}`, '_blank', 'noopener');
    return { mode: file ? 'downloaded' : 'web', copied: false };
  },
  getAutostart: async () => false,
  setAutostart: async () => undefined,
  onUpdateDownloaded: () => () => undefined,
  onNavigate: () => () => undefined,
  onOpenOffice: () => () => undefined,
};

(window as unknown as { tt: TtApi }).tt = tt;
document.documentElement.classList.add('is-web');
